import { MappableModel } from './mappable-model'

export class UserServicePreference extends MappableModel {
  public id?: number
  public key: string
  public datatype: string
  public default: string | boolean | number | null
  public description: string
  public display_name: string
}
